import AboutDoors from './components/AboutDoors';

export const aboutDoors = {
  firstLevel: AboutDoors,
};